export default import.meta.ROLLDOWN_FILE_URL_ZhtirC4ENZfjisomYZdNfQ